module.exports = __webpack_public_path__ + "static/media/scumbar.756955a9.gif";